import { PricingCategory } from './product';

export enum Condition {
  Yes = 'Y',
  No = 'N',
  Empty = '',
}

export enum Theme {
  Default = 'default',
  Training = 'training',
}

export type WithDataTest = Readonly<{
  dataTestId: string;
}>;

export type WithOptionalDataTest = Readonly<{
  dataTestId?: string;
}>;

export type JsonDataItem = Record<string, any>;
export type JsonData = JsonDataItem[];

export type MenuState = {
  openKeys?: string[];
  selectedKeys?: string[];
};

export type BreadcrumbLink = {
  url?: string;
  action?: () => void;
  title: React.ReactNode | string;
};

export enum RecordLockType {
  Customer = 'customer_edit',
  Job = 'job_edit',
  Quote = 'quote_edit',
  Technician = 'technician_edit',
}

export type Arg0<T extends (...args: any[]) => any> = NonNullable<NonNullable<Parameters<T>>[0]>;

export type PaginatedApiResponse<T> = {
  data: T;
  meta: {
    current_page: number;
    total: number;
    per_page: number;
    [x: string]: number;
  };
};

export type WithFieldsAsStrings<T extends object, F extends string = 'createdAt' | 'updatedAt'> = {
  [k in keyof T]: k extends F
    ? string
    : Extract<T[k], object> extends object
      ? WithFieldsAsStrings<Extract<T[k], object>, F> | Exclude<T[k], object>
      : T[k];
};

export type WithTimestamps<T extends object, F extends string = 'createdAt' | 'updatedAt'> = T & {
  [k in F]: Date | null;
};

export type WithoutTimestamps<T extends object, F extends string = 'createdAt' | 'updatedAt'> = Omit<T, F>;

export type Customer = {
  name: {
    full_name: string;
    contact1_firstname: string;
    contact1_surname: string;
    contact1_title: string;
    preferred_name: string;
    contact2_firstname: string;
    contact2_surname: string;
  };
  contact1: {
    contact1_mobile: string;
    contact1_work: string;
  };
  second_contact: 'Y' | 'N';
  contact2: {
    contact2_mobile: string;
    contact2_work: string;
  };
  address: {
    full_address: string;
    map_address: string;
    address_line_1: string;
    address_line_2: string;
    suburb_ID: number;
    suburb: string;
    state: string;
    postcode: string;
  };
  same_address: 'Y' | 'N';
  postal_address: {
    postal_full_address: string;
    postal_address_line_1: string;
    postal_address_line_2: string;
    postal_suburb_ID: number;
    postal_suburb: string;
    postal_state: string;
    postal_postcode: string;
  };
  ID: number;
  email: string;
  access_notes: string;
  special_notes: string;
  contact: string[];
  mobile: string[];
  card_on_file: boolean;
  prepaid: boolean;
  is_card_valid: boolean;
  invoiced: boolean;
  type: 'Personal' | 'Company';
  is_parent: boolean;
  is_geek_cover: boolean;
  has_pending_or_active_geek_cover: boolean;
  timezone: string;
  ow30dba: boolean;
  blacklist: 'Y' | 'N';
  blacklist_reason?: string;
  overdue: 'Y' | 'N';
  bad_debt: 'Y' | 'N';
  billto_ID?: string;
  billto_name?: string;
  customer_type?: PricingCategory;
  abn?: string;
  company_name?: string;
  phone?: string;
  hear_about_us?: string;
  status?: string;
};

export type Message = {
  job_ID: number;
  message: string;
  user_ID: number;
  link_type: string;
  link_ID: number;
  user: {
    name: string;
    ID: number;
    role: string;
  };
  link_name: string;
};

export type SMS = Message & {
  datetime: string;
  number: string;
  response: string;
};
export type Email = Message & {
  email: string;
  subject: string;
  sent_datetime: string;
  sent: Condition;
  response_code: string;
  name: string;
};

export type EmailTemplate = {
  ID: number;
  name: string;
  subject: string;
  body: string;
};

export type SmsTemplate = {
  ID: number;
  name: string;
  message: string;
};

export type ProfileNoteType = {
  ID: number;
  name: string;
};

export type ActionData = {
  id: string;
  label: string;
  description?: string | null;
  isEnabled?: boolean;
};
